import { AnchorGroup } from "@/components/anchors-navigation";
import FilterButton from "@/components/filtering/Button";
import { Element, useNode } from "@craftjs/core";
import StepButton from "./components/Button";
import StepButtonContainer from "./components/ButtonContainer";
import ContentContainer from "./components/ContentContainer";
import StepHeading from "./components/Heading";
import StepParagraph from "./components/Paragraph";
import StepTextContainer from "./components/TextContainer";

const Step2Content = () => {
    const {
        connectors: { connect },
    } = useNode();

    return (
        <div ref={(ref) => connect(ref!)}>
            <main className="container relative mx-auto 2xl:px-[108px] z-[1] pb-[160px]">
                <div className="relative grid grid-cols-[auto_64px_1fr] gap-13 gap-y-50 mt-36">
                    <AnchorGroup>
                        <FilterButton />
                    </AnchorGroup>

                    <div className="relative w-full col-start-2">
                        <span id="lead-0" className="absolute -top-36 w-16 h-1" />
                        <span
                            id="lead-1"
                            className="absolute -right-[0.5px] rounded-full bg-primary-200 text-primary-500 w-16 h-16 text-[35px] inline-flex items-center justify-center font-bold z-1 select-none"
                        >
                            A
                        </span>
                    </div>
                    <div>
                        <Element
                            id="heading-a"
                            is={StepHeading}
                            text={` Télécharger le fichier <span class="text-primary-500">IDS</span>`}
                        />

                        <Element id="container-a" is={ContentContainer} canvas>
                            <Element id="content-a" is={StepTextContainer} canvas>
                                <Element
                                    id="paragraph-a-1"
                                    is={StepParagraph}
                                    text={`Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec quam lacus, tristique at <a href="#">nulla et, imperdiet molestie nibh</a>. Vestibulum mollis viverra odio vitae sodales.`}
                                />
                            </Element>

                            <Element id="buttons-ba" is={StepButtonContainer} canvas columns={1}>
                                <Element
                                    id="buttons-a-1"
                                    is={StepButton}
                                    text="Télécharger les fichiers sur base des filtres pré-remplis"
                                    href="#"
                                />
                            </Element>
                        </Element>
                    </div>

                    <div className="relative w-full  col-start-2">
                        <span
                            id="lead-2"
                            className="absolute -right-[0.5px] rounded-full bg-primary-200 text-primary-500 w-16 h-16 text-[35px] inline-flex items-center justify-center font-bold z-1 select-none"
                        >
                            B
                        </span>
                    </div>
                    <div>
                        <Element
                            id="heading-b"
                            is={StepHeading}
                            text={`Contrôler <span class="text-primary-500">le modèle</span>`}
                        />

                        <Element id="container-b" is={ContentContainer} canvas>
                            <Element id="content-b" is={StepTextContainer} canvas>
                                <Element
                                    id="paragraph-b-1"
                                    is={StepParagraph}
                                    text={`Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec quam lacus, tristique at <a class="font-bold text-primary-500 hover:text-primary-600 hover:underline">nulla et, imperdiet molestie nibh</a>. Vestibulum mollis viverra odio vitae sodales.`}
                                />
                            </Element>

                            <Element id="buttons-b" is={StepButtonContainer} canvas columns={2}>
                                <Element id="buttons-b-1" is={StepButton} text="Sur base d'un fichie IDS" href="#" />
                                <Element id="buttons-b-2" is={StepButton} text="Via d'autres méthodes" href="#" />
                            </Element>
                        </Element>
                    </div>

                    <div className="relative w-full  col-start-2">
                        <span
                            id="lead-3"
                            className="absolute -right-[0.5px] rounded-full bg-primary-200 text-primary-500 w-16 h-16 text-[35px] inline-flex items-center justify-center font-bold z-1 select-none"
                        >
                            C
                        </span>
                    </div>
                    <div>
                        <Element
                            id="heading-c"
                            is={StepHeading}
                            text={`Diffuser <span class="text-primary-500">le modèle</span>`}
                        />
                        <Element id="container-c" is={ContentContainer} canvas>
                            <Element id="content-c" is={StepTextContainer} canvas>
                                <Element
                                    id="paragraph-c-1"
                                    is={StepParagraph}
                                    text={`Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec quam lacus, tristique at <a class="font-bold text-primary-500 hover:text-primary-600 hover:underline">nulla et, imperdiet molestie nibh</a>. Vestibulum mollis viverra odio vitae sodales.`}
                                />
                            </Element>

                            <Element id="buttons-c" is={StepButtonContainer} canvas columns={2} />
                        </Element>
                    </div>

                    <div className="col-start-3 place-self-center">
                        <div id="lead-4">
                            <Element
                                id="heading-d"
                                is={StepHeading}
                                text={`Votre modèle est <span class="text-primary-500">validé</span>`}
                            />
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

Step2Content.craft = {
    displayName: "Content",
    rules: {
        canDrag: () => false,
        canMoveOut: () => false,
    },
    custom: {
        canDelete: false,
    },
};

export default Step2Content;
